var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatingIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 48C0 25.3726 0 14.0589 7.02944 7.02944C14.0589 0 25.3726 0 48 0H52C74.6274 0 85.9411 0 92.9706 7.02944C100 14.0589 100 25.3726 100 48V52C100 74.6274 100 85.9411 92.9706 92.9706C85.9411 100 74.6274 100 52 100H48C25.3726 100 14.0589 100 7.02944 92.9706C0 85.9411 0 74.6274 0 52V48Z",
  fill: "#0077FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M52 0H48C25.3726 0 14.0589 0 7.02944 7.02944C0.881095 13.1778 0.11044 22.6037 0.0138429 40.0108L50 79L99.9862 40.0108C99.8896 22.6037 99.1189 13.1778 92.9706 7.02944C85.9411 0 74.6274 0 52 0Z",
  fill: "#FF22A6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7743 75.0108L36.7431 74.9865C31.3598 70.7848 26.6568 67.0214 23.4815 63.1009C19.6965 58.4276 18 53.5134 18 47.6299C18 35.5062 27.9218 26 39.7059 26C43.4944 26 46.929 26.9306 49.9771 28.5554C53.0386 26.9237 56.4911 26 60.2941 26C72.0782 26 82 35.5062 82 47.6299C82 53.5134 80.3035 58.4276 76.5185 63.1009C73.3432 67.0214 68.6402 70.7848 63.2569 74.9865L63.2257 75.0108L57.5204 79.4279C53.0907 82.8574 46.9093 82.8574 42.4796 79.4279L36.7743 75.0108ZM55.0206 37.2883C53.1991 38.1827 51.5256 39.5744 50 41.4633C48.4003 39.5234 46.6623 38.1079 44.7861 37.2169C43.1924 36.46 41.499 36.0816 39.7059 36.0816C33.3007 36.0816 28.0393 41.2391 28.0393 47.6299C28.0393 54.8055 31.6994 58.2812 42.9039 67.0265L48.6092 71.4436C49.4269 72.0766 50.5731 72.0766 51.3908 71.4436L57.0961 67.0265C68.3006 58.2812 71.9607 54.8055 71.9607 47.6299C71.9607 41.2391 66.6993 36.0816 60.2941 36.0816C58.4166 36.0816 56.6587 36.4838 55.0206 37.2883Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dating_icon.e1499f635a6724264eae28fb41ad1183.svg";